import { Navigate } from 'react-router-dom';
import { ReactNode } from 'react';

interface RoleGuardProps {
  children: ReactNode;
  allowedRoles: string[];
  redirectTo?: string;
}

const RoleGuard = ({ children, allowedRoles, redirectTo }: RoleGuardProps) => {
  const userRole = (localStorage.getItem('role') || '').toLowerCase();
  const userId = localStorage.getItem('userId') || '';

  // Check if user's role is allowed
  const isAllowed = allowedRoles.some(role => role.toLowerCase() === userRole);

  if (!isAllowed) {
    // Redirect to the specified path or default to all-projects
    const defaultRedirect = `/project/${userId}/all-projects`;
    return <Navigate to={redirectTo || defaultRedirect} replace />;
  }

  return <>{children}</>;
};

export default RoleGuard;
